import { render } from "./MyPR.vue?vue&type=template&id=11f755e2&scoped=true"
import script from "./MyPR.vue?vue&type=script&lang=js"
export * from "./MyPR.vue?vue&type=script&lang=js"

import "./MyPR.vue?vue&type=style&index=0&id=11f755e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f755e2"]])

export default __exports__